import React from "react";
import { FormGroup, Label } from "reactstrap";
import Select from "react-select";

/**
 * Multi-select opcional de grupos pra segregação de campo.
 *
 * - Se o usuário não escolher nenhum grupo, o campo NÃO é segregado (todos veem).
 * - Se escolher 1+ grupos, o campo só é visível pra participantes desses grupos.
 *
 * Props:
 * - groups: array de grupos [{id, name}].
 * - groupIds: array de UUIDs selecionados (controlado).
 * - onChange(groupIds): callback com o novo array de UUIDs.
 * - fieldPrefix: string única por input (evita colisão de ids).
 */
export default function GroupSegregationSection({
  groups = [],
  groupIds = [],
  onChange,
  fieldPrefix = "segregate",
}) {
  // Só faz sentido pra forms NÃO-cadastro. O CustomForm passa groups=[]
  // quando o form é de cadastro (isRegister === "sim") — nesse caso, o
  // componente inteiro é omitido do modal de configuração do campo.
  if (!groups || groups.length === 0) return null;

  const options = groups.map((g) => ({ label: g.name, value: g.id }));
  const selectedOptions = options.filter((opt) => groupIds.includes(opt.value));

  const handleGroupsChange = (selected) => {
    onChange((selected || []).map((s) => s.value));
  };

  return (
    <FormGroup className="input-margin-btm" id={fieldPrefix}>
      <Label className="form-label">
        Para segregar informe o(s) grupo(s) que podem visualizar o campo?
      </Label>
      <Select
        value={selectedOptions}
        isMulti
        placeholder="Selecione"
        onChange={handleGroupsChange}
        options={options}
        noOptionsMessage={() => "Nenhum grupo encontrado"}
        classNamePrefix="select2-selection"
      />
    </FormGroup>
  );
}
